import i18n from '../i18n';

// Category translation map - keys must match exactly what's in the database
const categoryTranslations = {
  he: {
    "Food & Dining": "אוכל ומסעדות",
    "Groceries": "מכולת",
    "Transportation": "תחבורה",
    "Housing": "דיור",
    "Entertainment": "בידור",
    "Shopping": "קניות",
    "Healthcare": "בריאות",
    "Travel": "נסיעות",
    "Education": "חינוך",
    "Other": "אחר",
    "Utilities": "חשבונות",
    "Insurance": "ביטוח",
    "Debt & Loans": "חובות והלוואות",
    "Savings & Investments": "חסכונות והשקעות",
    "Kids / Family": "ילדים / משפחה",
    "Pets": "חיות מחמד",
    "Subscriptions": "מנויים",
    "Gifts & Donations": "מתנות ותרומות",
    "Personal Care": "טיפוח אישי",
    "Business / Work Expenses": "הוצאות עסקיות / עבודה"
  }
};

/**
 * Translates a category name from English to the current UI language.
 * Categories are stored in English in the database, but displayed in the user's language.
 * 
 * @param {string} categoryName - The English category name from the database
 * @returns {string} - The translated category name, or the original if no translation exists
 */
export function translateCategory(categoryName) {
  if (!categoryName) return '';
  
  const currentLang = i18n.language;
  
  // If English or no translation exists, return original
  if (currentLang === 'en' || !categoryTranslations[currentLang]) {
    return categoryName;
  }
  
  // Return translated name or original if not found
  return categoryTranslations[currentLang][categoryName] || categoryName;
}

/**
 * Hook-friendly version that can be used in components
 * Returns a function that translates category names
 * 
 * @param {function} t - The translation function from useTranslation (not used, kept for API compatibility)
 * @returns {function} - A function that translates category names
 */
export function getCategoryTranslator(t) {
  return translateCategory;
}
